import i18next from 'i18next';
import { __DEBUG__, DEFAULT_LANGUAGE } from '../constants';

import en from './locales/en.json';
import langcodes from './locales/langcodes.json';
import countries from './locales/countries.json';

i18next.init({
  ns: ['translation', 'langcodes', 'countries'],
  defaultNS: 'translation',
  fallbackLng: DEFAULT_LANGUAGE,
  fallbackNS: ['translation'],
  resources: {
    en: {
      translation: en,
      langcodes,
      countries,
    },
  },
  parseMissingKeyHandler: (missing, fallback) => {
    if (__DEBUG__) {
      console.warn('MISSING TRANSLATION:', missing);
    }
    return fallback || missing;
  },
});

i18next.languages = ['en'];

export default i18next;
